import { Theme, useTheme } from '@material-ui/core';
import styledFuncs from 'app/styles/styledFuncs';
import React, { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

type DefaultStyleProps = {
  theme: Theme;
  left: boolean; // push in from left side (true) or right (false)?
};
const defaultStyle = ({ theme, left }: DefaultStyleProps) => ({
  transition: styledFuncs.createTransition(['transform'])({ theme }),
  transform: `translateX(${left ? '-' : ''}110%)`,
  boxShadow: `${left ? '' : '-'}2px 0px 40px 0px rgb(0 0 0 / 12%)`,
});

const transitionedStyle = {
  transform: 'translateX(0px)',
};

const transitionStyles = {
  entering: transitionedStyle,
  entered: transitionedStyle,
  exiting: {},
  exited: {},
  unmounted: {},
};

type Props = {
  children?: React.ReactNode;
  in: boolean;
  className?: string;
  side: 'right' | 'left';
};
export default function PushInFrom({
  in: inProp,
  children,
  className,
  side,
}: Props): JSX.Element {
  const theme = useTheme();
  const nodeRef = useRef(null);

  const left = side === 'left';
  return (
    <CSSTransition
      timeout={{
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen,
      }}
      in={inProp}
      mountOnEnter
      unmountOnExit
      {...{ nodeRef }}
    >
      {state => (
        <div
          ref={nodeRef}
          style={{
            ...defaultStyle({ theme, left }),
            ...transitionStyles[state],
          }}
          {...{ className }}
        >
          {children}
        </div>
      )}
    </CSSTransition>
  );
}
